import { useEffect, useMemo, useState } from 'react';
import { datadogLogs } from '@datadog/browser-logs';
import { getDeviceType } from '../utils/device-detection';
import { DeviceType } from '../types/device-types';
var MIN_KEYBOARD_HEIGHT = 300;
// BASED ON: https://github.com/straxico/use-detect-keyboard-open/blob/main/src/index.js
var useDetectKeyboardOpen = function () {
    var _a = useState(false), isKeyboardOpen = _a[0], setIsKeyboardOpen = _a[1];
    useEffect(function () {
        var listener = function () {
            var _isKeyboardOpen = window.screen.height - MIN_KEYBOARD_HEIGHT >
                window.visualViewport.height;
            datadogLogs.logger.info("adp_scroll_test screen.height=(".concat(window.screen.height, ") visualViewport.height=(").concat(window.visualViewport.height, ")"));
            if (isKeyboardOpen !== _isKeyboardOpen) {
                setIsKeyboardOpen(_isKeyboardOpen);
            }
        };
        if (typeof visualViewport !== 'undefined') {
            window.visualViewport.addEventListener('resize', listener);
        }
        return function () {
            if (typeof visualViewport !== 'undefined') {
                window.visualViewport.removeEventListener('resize', listener);
            }
        };
    }, [isKeyboardOpen]);
    var deviceType = useMemo(function () { return getDeviceType(); }, []);
    datadogLogs.logger.info("adp_scroll_test isKeyboardOpen=(".concat(isKeyboardOpen, ") deviceType=(").concat(deviceType, ")"));
    if (deviceType !== DeviceType.IOS && deviceType !== DeviceType.ANDROID) {
        return false;
    }
    return isKeyboardOpen;
};
export default useDetectKeyboardOpen;
